import { usePopperoDrawero } from "@pinkyhead/dovekit";
import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useRoot } from "../../../context/root";
import { createFakeSrcSetObject } from "../../../utils";

export const useResults = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { geohash } = useParams(); 
  const { extraMarker } = useRoot();

  const [open, setOpen] = useState(() => {
    const openStateFromParams = searchParams.get("open");
    if (openStateFromParams === "true") {
      return true;
    }
    return false;
  })

  useEffect(() => {
    if (open) {
      searchParams.set("open", "true");
      navigator({
        pathname: location.pathname,
        search: searchParams.toString()
      })
    }
    else {
      searchParams.delete("open");
      navigator({
        pathname: location.pathname,
        search: searchParams.toString()
      })
    }
  }, [open])

  const redirectToProfile = (id: string) => {
    if (geohash) {
      navigator({
        pathname: `${process.env.REACT_APP_INTERNAL_URL}bucket/${geohash}/details/${id}`,
        search: searchParams.toString()
      });
    }
    else {
      navigator({
        pathname: `${process.env.REACT_APP_INTERNAL_URL}details/${id}`,
        search: searchParams.toString()
      });
    }
  }


  return {
    open,
    setOpen,
    userData: extraMarker?.data ? {
      ...extraMarker.data,
      picture: createFakeSrcSetObject(extraMarker.data.picture)
    } : null,
    redirectToProfile
  }

}
